export function formatNumericUSDate(date) {
  return date.toLocaleString('en-us', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });
}
export function formatLongMonthUSDate(date) {
  let timeZone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'UTC';
  return date.toLocaleString('en-us', {
    timeZone,
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}
export const formatShortMonthUSDate = date => date.toLocaleDateString('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric'
});
export function formatDateTimeWithLongMonth(date) {
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  });
}
export function formatDateTimeWithShortMonth(date) {
  const datePart = date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
  const timePart = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  });
  return "".concat(datePart, " ").concat(timePart);
}